// extracted by mini-css-extract-plugin
export default {"ScreenLock":"Page_ScreenLock__pw+5O"};